import "./Home.scss";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import HomeTeacher from "./HomeTeacher";
import HomeStudent from "./HomeStudent";
import HomeAffiliate from "./HomeAffiliate";
import HomeCompanyManager from "./HomeCompanyManager";
import Header from "../../components/Header/NewHeader";
import HomeCustomerService from "./HomeCustomerService";
import SideMenu from "../../components/SideMenu/SideMenu";
import { loadUserStorage } from "../../store/middleware/user.middleware";

function Home() {
  const dispatch = useDispatch();
  const { user, checkout } = useSelector((state) => state.userReducer);

  const loadInfos = async () => {
    !checkout && (await dispatch(loadUserStorage(true, false)));
  };

  const showHome = (role) => {
    switch (role) {
      case "affiliate":
        return <HomeAffiliate />;
      case "student":
        return <HomeStudent />;
      case "teacher":
        return <HomeTeacher />;
      case "customerService":
        return <HomeCustomerService />;
      case "companyManager":
        return <HomeCompanyManager />;
      default:
        break;
    }
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header />
        {user && showHome(user?.role)}
      </section>
    </div>
  );
}

export default Home;
